import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as CurrencyActions from './currency.actions';
import { CurrencyService } from '../../services/currency.service';

@Injectable()
export class CurrencyEffects {
  loadCurrency$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrencyActions.loadCurrency),
      exhaustMap((_) =>
        this.currencyService.getCurrency().pipe(
          map((data) =>
            CurrencyActions.loadCurrencySuccess({ currency: data })
          ),
          catchError((error) =>
            of(CurrencyActions.loadCurrencyFailure({ error }))
          )
        )
      )
    )
  );

  addCurrency$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrencyActions.addCurrency),
      concatMap(({ newCurrency }) =>
        this.currencyService.createCurrency(newCurrency).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return CurrencyActions.addCurrencySuccess({ newCurrency: data });
          }),
          catchError((error) =>
            of(
              CurrencyActions.addCurrencyFailure({ error: error.error.message })
            )
          )
        )
      )
    )
  );

  updateCurrency$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrencyActions.updateCurrency),
      map((action) => action.updateCurrency),
      concatMap((updateCurrency) =>
        this.currencyService.updateCurrency(updateCurrency).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return CurrencyActions.updateCurrencySuccess({
              updateCurrency: updateCurrency,
            });
          }),
          catchError((error) =>
            of(CurrencyActions.updateCurrencyFailure({ error: error.message }))
          )
        )
      )
    )
  );

  removeCurrency$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrencyActions.removeCurrency),
      map((action) => action.ids),
      concatMap((ids) =>
        this.currencyService.deleteCurrency(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return CurrencyActions.removeCurrencySuccess({ ids });
          }),
          catchError((error) =>
            of(CurrencyActions.updateCurrencyFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private currencyService: CurrencyService,
    private notification: NotificationService
  ) {}
}
